import { render } from "./HafedChat.vue?vue&type=template&id=7d6c2332"
import script from "./HafedChat.vue?vue&type=script&lang=js"
export * from "./HafedChat.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__